/* 姜維（字伯約） */
import { sigOf } from '../../core/kit.ts';
import { defineHero, hook } from '../define.ts';

export default defineHero({
  id: 'jiangwei', name: '姜維', sub: '字伯約', faction: 'shu', role: '戰士', weapon: 'spear',
  look: { fx: '#9fe0ff', c: { plume: '#46935c', armor: '#4a8a5c', cape: '#2c573b' } },
  skills: [
    ['麒麟槍', 'multi', '槍法三段，第三段挑空目標。每段 {55/90/125/160} 傷害。'],
    ['九伐中原', 'charge', '衝鋒造成 {70/110/150/190} 傷害；每命中一名武將，這招冷卻減 2 秒。', { sig: 'ninecamp' }],
    ['膽大如斗', 'passive', '被控制時間 -{10/15/20/25}%。', { pv: {}, sig: 'tenacity', ten: [10, 15, 20, 25] }],
    ['麒麟降世', 'thunder', '召下麒麟天雷，範圍 {260/390/520} 傷害並暈眩 1.2 秒。', { col: '#9fe0ff', el: 'thunder' }],
  ],
  // 被動與專屬效果：hook(時間點, 順位, 處理)（時間點一覽見 core/hooks.ts）
  hooks: [
    // 九伐中原：每撞到一名武將，這招冷卻 -2 秒
    hook('damage.after', 10, function (c, lost) {
      const act0 = c.act, t = c.t, own0 = c.own;
      if (act0 && lost > 0 && own0.team !== t.team && act0.sk.sig === 'ninecamp' && t.kind === 'hero' && !(act0.nine || (act0.nine = {}))[t.id]) { act0.nine[t.id] = 1; own0.cd[act0.i] = Math.max(0, own0.cd[act0.i] - 2); }
    }),
    // 膽大如斗：硬控制時間縮短
    hook('cc.tenacity', 20, function (t, cc) { const tn = sigOf(t, 'tenacity'); return tn ? tn.v('ten') : 0; }),
  ],
});
